class AuthService {
  private STORAGE_AUTH_TOKEN_KEY = 'clientAuthToken'
  private STORAGE_IS_TOKEN_SIGN_IN_KEY = 'isTokenSignIn'
  private STORAGE_CONTRACTOR_PORTAL_AUTH_TOKEN_KEY = 'contractorPortalAuthToken'
  // legacy keys, can be removed after all users have migrated to the new key
  private STORAGE_RECOLLECTION_AUTH_TOKEN_KEY = 'recollectionAuthToken'
  private STORAGE_ONBOARDING_AUTH_TOKEN_KEY = 'onboardingAuthToken'

  public setStoredAuthToken(authToken: string | null) {
    if (!authToken) {
      localStorage.removeItem(this.STORAGE_AUTH_TOKEN_KEY)

      return
    }

    localStorage.setItem(this.STORAGE_AUTH_TOKEN_KEY, authToken)
  }

  public setStoredOnboardingToken(authToken: string | null) {
    if (!authToken) {
      localStorage.removeItem(this.STORAGE_ONBOARDING_AUTH_TOKEN_KEY)

      return
    }

    localStorage.setItem(this.STORAGE_ONBOARDING_AUTH_TOKEN_KEY, authToken)
  }

  public setStoredRecollectionToken(authToken: string | null) {
    if (!authToken) {
      localStorage.removeItem(this.STORAGE_RECOLLECTION_AUTH_TOKEN_KEY)

      return
    }

    localStorage.setItem(this.STORAGE_RECOLLECTION_AUTH_TOKEN_KEY, authToken)
  }

  public getStoredAuthToken(): string | null {
    const authToken = localStorage.getItem(this.STORAGE_AUTH_TOKEN_KEY)

    return authToken
  }

  public getStoredOnboardingToken(): string | null {
    const authToken = localStorage.getItem(this.STORAGE_ONBOARDING_AUTH_TOKEN_KEY)

    return authToken
  }

  public getStoredRecollectionToken(): string | null {
    const authToken = localStorage.getItem(this.STORAGE_RECOLLECTION_AUTH_TOKEN_KEY)

    return authToken
  }

  public setStoredIsTokenSignIn(isTokenSignIn: boolean | null) {
    if (isTokenSignIn === null) {
      localStorage.removeItem(this.STORAGE_IS_TOKEN_SIGN_IN_KEY)

      return
    }

    localStorage.setItem(this.STORAGE_IS_TOKEN_SIGN_IN_KEY, JSON.stringify(isTokenSignIn))
  }

  public getStoredIsTokenSignIn(): boolean | null {
    const isTokenSignIn = localStorage.getItem(this.STORAGE_IS_TOKEN_SIGN_IN_KEY)

    return isTokenSignIn ? JSON.parse(isTokenSignIn) : null
  }

  public setStoredContractorPortalAuthToken(authToken: string | null) {
    if (!authToken) {
      localStorage.removeItem(this.STORAGE_CONTRACTOR_PORTAL_AUTH_TOKEN_KEY)

      return
    }

    localStorage.setItem(this.STORAGE_CONTRACTOR_PORTAL_AUTH_TOKEN_KEY, authToken)
  }

  public getStoredContractorPortalAuthToken(): string | null {
    const authToken = localStorage.getItem(this.STORAGE_CONTRACTOR_PORTAL_AUTH_TOKEN_KEY)

    return authToken
  }
}

export const authService = new AuthService()
